import { render, staticRenderFns } from "./ModalOrdenDigital.vue?vue&type=template&id=dcba4a58&scoped=true"
import script from "./ModalOrdenDigital.vue?vue&type=script&lang=js"
export * from "./ModalOrdenDigital.vue?vue&type=script&lang=js"
import style0 from "./ModalOrdenDigital.vue?vue&type=style&index=0&id=dcba4a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcba4a58",
  null
  
)

export default component.exports